import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { lenisStore, scrollToSection } from "../lib/lenisStore";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Manifesto from "../components/Manifesto";
import Gallery from "../components/Gallery";
import About from "../components/About";
import Packages from "../components/Packages";
import Testimonials from "../components/Testimonials";
import JournalStrip from "../components/JournalStrip";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    lenisStore.instance = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisStore.instance = null;
    };
  }, []);

  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToSection(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <Navbar />
      <MobileMenu />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Gallery />
        <About />
        <Packages />
        <Testimonials />
        <JournalStrip />
        <ContactForm />
      </main>
      <Footer />
    </>
  );
}
